import dynamicRewardsTabContent from './dynamicRewardsTabContent';

export default dynamicRewardsTabContent;
